import { Outlet } from "react-router-dom";

const NotFoundHandler = () => {
  return <Outlet />;
};

export default NotFoundHandler;
